module.exports = __webpack_public_path__ + "static/media/no_medal.be38af65.png";